import moment from "moment";

// Set default due date and time to one week from today at noon
const defaultEventDate = moment()
  .hour(12)
  .minute(0)
  .seconds(0)
  .add(14, "days");

export const devDefaultState = {
  userInput: {
    squadMembers: {
      costume: true,
      live: false,
      cheer: false,
      crockett: false,
      isValid: null
    },
    organization: {
      val: "Test Org",
      isValid: null
    },
    type: {
      val: "business"
    },
    contactName: {
      val: "SOME NAME",
      isValid: null
    },
    phone: {
      val: "1234567890",
      isValid: null
    },
    email: {
      val: "test@test.com",
      isValid: null
    },
    // We're calling this 'due' even though it's just the event date
    due: {
      val: defaultEventDate,
      isValid: true
    },
    description: {
      val: "SOME STUFF",
      isValid: null
    },
    locationName: {
      val: "SOME PLACE",
      isValid: null
    },
    locationAddress: {
      val: "123 Main Street",
      isValid: null
    },
    locationCity: {
      val: "Anytown",
      isValid: null
    },
    locationState: {
      val: "TN",
      isValid: null
    },
    locationZip: {
      val: "12345",
      isValid: null
    }
  }
};

export const defaultState = {
  userInput: {
    squadMembers: {
      costume: false,
      live: false,
      cheer: false,
      crockett: false,
      isValid: null
    },
    organization: {
      val: "",
      isValid: null
    },
    type: {
      val: "business"
    },
    contactName: {
      val: "",
      isValid: null
    },
    phone: {
      val: "",
      isValid: null
    },
    email: {
      val: "",
      isValid: null
    },
    eventName: {
      val: "",
      isValid: null
    },
    // We're calling this 'due' even though it's just the event date
    due: {
      val: defaultEventDate,
      isValid: true
    },
    description: {
      val: "",
      isValid: null
    },
    locationName: {
      val: "",
      isValid: null
    },
    locationAddress: {
      val: "",
      isValid: null
    },
    locationCity: {
      val: "",
      isValid: null
    },
    locationState: {
      val: "",
      isValid: null
    },
    locationZip: {
      val: "",
      isValid: null
    },
    termsAgreed: {
      val: false,
      isValid: null
    }
  }
};



// WEBPACK FOOTER //
// ./src/Spirit/defaultState.js